import { render, staticRenderFns } from "./BalanceStructureWith.vue?vue&type=template&id=5ab2b661&"
import script from "./BalanceStructureWith.vue?vue&type=script&lang=js&"
export * from "./BalanceStructureWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports